import React from 'react';
import { useBanner } from '../../context/BannerContext';
import Banner from './Banner';
import './GlobalBannerArea.css';

const GlobalBannerArea = () => {
  const { banners, removeBanner } = useBanner();

  if (!banners || banners.length === 0) {
    return null;
  }

  return (
    <div className="global-banner-area">
      {banners.map((banner) => (
        <Banner key={banner.id} banner={banner} onDismiss={removeBanner} />
      ))}
    </div>
  );
};

export default GlobalBannerArea;
